export default __webpack_public_path__ + "static/media/Etape3_Favereaux.450611eb.jpg";